import { preffixTestIds } from "utility/e2e";

export const AddressFormTestIds = preffixTestIds("address-form")({
    SAVE: "save"
})